// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@monsma/MobiusOverrides/Tooltip/Tooltip";
import Information from "@monsma/XDL/Icons/Information";
import { xBaseTheme } from "@monsma/XDL/types";
import color, { getSystemColor } from "@monsma/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            drawerContent: {
                css: css`
                    background-color: ${color("common.background")};
                `,
            },
            tooltipContent: {
                css: css`
                    background-color: ${color("common.background")};
                    padding: 10px 10px 15px;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 22px;
                    max-width: 268px;
                    border: 1px solid ${color("common.ui12")};
                    border-radius: 6px;
                    min-width: 80px;
                `,
            },
            tooltipArrow: {
                stroke: getSystemColor("common.border"),
                fill: getSystemColor("common.background"),
                width: 23,
                height: 15,
                tipRadius: 2,
            },
        },
        iconProps: {
            src: Information,
            size: 16,
            color: "secondary",
            css: css``,
        },
        typographyProps: {
            size: "13px",
            lineHeight: "22px",
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
